/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PaymentsMethods,
  PaymentsMethodsInterface,
  PaymentsConstructor,
} from "../PaymentsMethods";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct PaymentsConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "enum Payment.PaymentTypes",
        name: "paymentType",
        type: "uint8",
      },
    ],
    name: "NewPayment",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "enum Payment.PaymentTypes",
        name: "paymentType",
        type: "uint8",
      },
    ],
    name: "pay",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct PaymentsConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type PaymentsMethodsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PaymentsMethodsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PaymentsMethods__factory extends ContractFactory {
  constructor(...args: PaymentsMethodsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PaymentsMethods";
  }

  deploy(
    input: PaymentsConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PaymentsMethods> {
    return super.deploy(input, overrides || {}) as Promise<PaymentsMethods>;
  }
  getDeployTransaction(
    input: PaymentsConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): PaymentsMethods {
    return super.attach(address) as PaymentsMethods;
  }
  connect(signer: Signer): PaymentsMethods__factory {
    return super.connect(signer) as PaymentsMethods__factory;
  }
  static readonly contractName: "PaymentsMethods";
  public readonly contractName: "PaymentsMethods";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PaymentsMethodsInterface {
    return new utils.Interface(_abi) as PaymentsMethodsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PaymentsMethods {
    return new Contract(address, _abi, signerOrProvider) as PaymentsMethods;
  }
}
